module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms_01_m.8420329ca27be39757eaa61d5453f756.png";